const injectChatScript = function (fields) {
    if (fields.chatId && fields.groupName) {
        function initScript() {
            const scriptInit = document.createElement('script');
            const scriptInitCode = "$FSLCInit('body').FocalScopeChat({group:'"+fields.groupName+"', lang:'__', fShowRegForm: true});";
            scriptInit.innerText = scriptInitCode;
            scriptInit.id = 'FocalScopeInitScript'+fields.groupName;
            document.body.appendChild(scriptInit);
        };

        const script = document.createElement('script');
        script.src = 'https://dfds.focalscope.com/lchat/script/FocalScopeChatLoadZero.js?__v='+fields.chatId;
        script.id = 'FocalScopeScript'+fields.chatId;
        if (script.readyState) {  // IE
            script.onreadystatechange = function() {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    initScript();
                }
            };
        } else { // others
            script.onload = function() {
                initScript();
            };
        }
        script.async = true;
        document.body.appendChild(script);

        if (typeof $FSLCInit === 'function') {
            initScript();
        }
    }
}

export default injectChatScript